import React, { useContext, useState } from "react";
import { UserDataContext } from "../context/User";
import axios from "axios";

const preferredSupportOptions = [
  "Peer Buddy",
  "Mentor Matching",
  "Affinity Group",
  "Workshops/Tutorials",
  "Gear Recommendations",
  "Feedback Cycles",
];

const skillAreasOptions = [
  "Composition",
  "Lighting",
  "Editing/Post-Processing",
  "Storytelling",
  "Posing/Directing",
  "Other",
];

const ProjectForm = () => {
  const [preview, setPreview] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const { userData } = useContext(UserDataContext);
  const initialFormData = {
  title: "",
  themeInspiration: "",
  projectDescription: "",
  goals: "",
  preferredSupport: [],
  skillAreas: [],
  userId: userData.id, // keep user ID
  agree: false,
  timeline:null,
  milestones:"",
  projectStatus:"Not Started",
  projectHistory:"",

};

  const [formData, setFormData] = useState(initialFormData);

  /* ----------------- HANDLERS ----------------- */

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleCheckboxChange = (name, value) => {
    setFormData((prev) => {
      const exists = prev[name].includes(value);
      return {
        ...prev,
        [name]: exists
          ? prev[name].filter((item) => item !== value)
          : [...prev[name], value],
      };
    });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setImageFile(file);
    setPreview(URL.createObjectURL(file));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = new FormData();
    payload.append("image", imageFile);
    payload.append("data", JSON.stringify(formData));


     try {
      const quest_submission = await axios.post(
        "/api/project/create",
        payload,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      if (quest_submission.data.success) {
        alert("Project Submission Successfully!");
        // reset form if needed
        setFormData(initialFormData);
        setImageFile(null);
        setPreview(null);
      }
    } catch (err) {
      console.error(err);
      alert("Failed to submit quest!");
    }
  };


  /* ----------------- UI ----------------- */

  return (
    <div
      className="mt-16 bg-white rounded-2xl p-8 max-w-4xl m-auto"
      style={{ boxShadow: "0 0 20px rgba(0,0,0,0.25)" }}
    >
       
      <h2 className="font-cinzel text-3xl md:text-4xl uppercase text-gray-900 text-center mb-6">
        Project Submission
      </h2>
     <div className="space-y-4 text-gray-800 font-outfit mb-4"> 
        <p> Start your Photography Project Journey. Declare your project to unlock community support, feedback, and a chance to shine in our gallery! Projects typically last 5-12 months. We’ll match you with resources, based on your needs </p>
      </div>
      {/* 🔹 ONE FORM ONLY */}
      <form onSubmit={handleSubmit} className="space-y-8">
          
       {/* ---------------- MEMBER INFORMATION ---------------- */}
<section className="space-y-6 pb-4">
  <h2 className="text-[20px] font-semibold">Member Information</h2>

  <div className="flex flex-wrap gap-6">

    <div>
      <label className="block text-xs font-semibold uppercase mb-2">
        Member ID
      </label>
      <input
        type="text"
        value={userData.memberId}
        disabled
        className="w-[350px] rounded-full border border-gray-300 px-4 py-3 text-sm text-gray-700 bg-gray-100 cursor-not-allowed"
      />
    </div>

    <div>
      <label className="block text-xs font-semibold uppercase mb-2">
        Membership Key
      </label>
      <input
        type="text"
        value={userData.membershipTier.key}
        disabled
        className="w-[350px] rounded-full border border-gray-300 px-4 py-3 text-sm text-gray-700 bg-gray-100 cursor-not-allowed"
      />
    </div>

    <div>
      <label className="block text-xs font-semibold uppercase mb-2">
        Full Name
      </label>
      <input
        type="text"
        value={[userData?.firstName, userData?.lastName].filter(Boolean).join(" ").trim() || userData?.preferredName || ""}
        disabled
        className="w-[350px] rounded-full border border-gray-300 px-4 py-3 text-sm text-gray-700 bg-gray-100 cursor-not-allowed"
      />
    </div>

  </div>
</section>


        {/* ---------------- IMAGE UPLOAD ---------------- */}
        <div>
          <label className="block text-xs font-semibold uppercase mb-2">
            Upload Profile Picture
          </label>

          <input
            type="file"
            accept="image/*"
            className="hidden"
            id="profilePic"
            onChange={handleFileChange}
          />

          <label
            htmlFor="profilePic"
            className="cursor-pointer rounded-3xl border border-dashed border-gray-300 px-6 py-10 flex flex-col items-center hover:bg-gray-50 transition"
          >
            {preview ? (
              <img
                src={preview}
                alt="Preview"
                className="h-[300px] w-[400px]  object-cover shadow"
              />
            ) : (
              <div className="h-12 w-12 flex items-center justify-center rounded-xl border text-2xl">
                +
              </div>
            )}

            <p className="mt-3 text-xs text-gray-500">
              {preview ? "Change image" : "Upload image"}
            </p>
          </label>
        </div>

        {/* ---------------- PROJECT DETAILS ---------------- */}
        <div>
          <label className="block text-xs font-semibold uppercase mb-2">
            Project Title
          </label>
          <input
            name="title"
            value={formData.title}
            onChange={handleChange}
            className="w-full rounded-full border px-4 py-3"
            placeholder="Enter project title"
            required
          />
        </div>

        <div>
          <label className="block text-xs font-semibold uppercase mb-2">
            Theme Inspiration
          </label>
          <textarea
            name="themeInspiration"
            value={formData.themeInspiration}
            onChange={handleChange}
            rows={2}
            placeholder="Enter your theme inspiration"
            className="w-full rounded-3xl border px-4 py-3"
          />
        </div>

        <div>
          <label className="block text-xs font-semibold uppercase mb-2">
            Project Description
          </label>
          <textarea
            name="projectDescription"
            value={formData.projectDescription}
            onChange={handleChange}
            rows={4}
            placeholder="Enter your project description"
            className="w-full rounded-3xl border px-4 py-3"
            required
          />
        </div>
        <div className="flex flex-wrap gap-[20px] justify-between">
         {/* Project Time Line */}
         <div>
      <label className="block text-xs font-semibold uppercase mb-2">
        Estimated Timeline
      </label>
      <input
  type="date"
  name="timeline"
  value={formData.timeline}
  onChange={handleChange}
        className="w-[350px] rounded-full border border-gray-300 px-4 py-3 text-sm text-gray-700 bg-gray-100"
      />
      </div>
      <div>
        <label
        className="block text-xs font-semibold uppercase mb-2"
        >Status Updates</label>
<select
  name="projectStatus"
  value={formData.projectStatus}
  onChange={handleChange}
  className="w-[350px] rounded-full border border-gray-300 px-4 py-3 text-sm text-gray-700 bg-gray-100"
>
  <option value="">Select status</option>
  <option value="Not Started">Not Started</option>
  <option value="In Progress">In Progress</option>
  <option value="Completed">Completed</option>
  <option value="On Hold">On Hold</option>
</select>

      
    </div>
    </div>
            <div>
          <label className="block text-xs font-semibold uppercase mb-2">
            Project Milestones
          </label>
          <textarea
            name="milestones"
            value={formData.milestones}
            onChange={handleChange}
            rows={2}
            placeholder="Enter your project milestones"
            className="w-full rounded-3xl border px-4 py-3"
          />
        </div>
                <div>
          <label className="block text-xs font-semibold uppercase mb-2">
            Project history log
          </label>
          <textarea
            name="projectHistory"
            value={formData.projectHistory}
            onChange={handleChange}
            rows={2}
            placeholder="Enter your Project history log"
            className="w-full rounded-3xl border px-4 py-3"
          />
        </div>
        {/* ---------------- GOALS ---------------- */}
        <div>
          <label className="block text-xs font-semibold uppercase mb-2">
            Primary Goals
          </label>
          <textarea
            name="goals"
            value={formData.goals}
            onChange={handleChange}
            rows={2}
            placeholder="Enter your project primary goals"
            className="w-full rounded-3xl border px-4 py-3"
          />
        </div>

        {/* ---------------- CHECKBOXES ---------------- */}
        <div>
          <h3 className="font-semibold mb-2">Preferred Support</h3>
          <div className="flex flex-wrap gap-4">
            {preferredSupportOptions.map((option) => (
              <label key={option} className="flex items-center gap-2">
                <input
                  type="checkbox"
                  checked={formData.preferredSupport.includes(option)}
                  onChange={() =>
                    handleCheckboxChange("preferredSupport", option)
                  }
                />
                {option}
              </label>
            ))}
          </div>
        </div>

        <div>
          <h3 className="font-semibold mb-2">Skill Areas to Develop</h3>
          <div className="flex flex-wrap gap-4">
            {skillAreasOptions.map((option) => (
              <label key={option} className="flex items-center gap-2">
                <input
                  type="checkbox"
                  checked={formData.skillAreas.includes(option)}
                  onChange={() =>
                    handleCheckboxChange("skillAreas", option)
                  }
                />
                {option}
              </label>
            ))}
          </div>
        </div>

        {/* ---------------- AGREEMENT ---------------- */}
        <label className="flex items-center text-start gap-2">
          <input
            type="checkbox"
            name="agree"
            checked={formData.agree}
            onChange={handleChange}
            required
          />I agree to LWBL's guidelines: Respect inclusivity, submit original work, and allow optional featuring in 'Shine' gallery upon completion.
           Data is private per our policy.
        </label>

        {/* ---------------- SUBMIT ---------------- */}
        <div className="flex justify-center">
          <button
            type="submit"
            className="rounded-full bg-gradient-to-r from-cyan-300 via-sky-400 to-cyan-500 px-10 py-2.5 text-white font-semibold"
          >
            Submit Entry
          </button>
        </div>

      </form>
    </div>
  );
};

export default ProjectForm;
